<template>
  <v-content>
    <v-container class="py-12">
      <h2 class="display-1" data-testid="confirmation-heading">
        Thanks for submitting your report!
      </h2>

      <p class="mt-4">
        Thank you for helping us improve the way we tag calls on our network.
        We’ve logged the following in our system:
      </p>

      <div class="mt-12 px-6 py-8" style="border-radius: 0; border: 1px solid #979797" flat>
        <h2 class="headline">What went wrong?</h2>
        <p class="mt-4">
          {{ data.category }}<br v-if="data.reason" />
          {{ data.reason }}
        </p>

        <h2 class="headline">Caller details</h2>
        <div class="mt-4">
          <p>
            <span data-testid="confirmation-phone-number"><b>Phone number:</b> {{ formattedPhoneNumber }} <br/></span>
            <span v-if="data.name"><b>Incoming Caller ID:</b> {{ data.name }} <br/></span>
            <span v-if="data.date"><b>Date of call:</b> {{ data.date }} <br/></span>
            <span v-if="data.time"><b>Time of call:</b> {{ data.time | formatTime }} <br/></span>
          </p>

          <p v-if="data.isPrerecorded" class="mt-4">
            This call was an articial or pre-recorded voicemail.
          </p>
        </div>
      </div>

      <div class="headline pt-8">What's next?</div>
      <p class="pt-4">
        Get back to enjoying life. We appreciate your help to improve Scam ID!
        You've done your part, we'll take it from here. Click here to
        <a v-bind:href=getCallReportingHomeURL>submit another report</a>
        or tap done to return to the home page. If you'd like
        to see what else T-Mobile is doing to keep you protected, check out the
        Learn More section below.
      </p>

      <div class="mt-12">
        <v-btn
          data-testid="btn-done"
          :color="isMagenta ? 'primary' : 'warning'"
          type="submit"
          large
          width="150px"
          :style="{
            'border-radius': isMagenta ? 0 : undefined
          }"
          elevation="0"
          :href="isMagenta
            ? 'https://www.t-mobile.com/customers/scam-shield'
            : 'https://www.metrobyt-mobile.com/scam-shield'"
        >Done</v-btn>
      </div>
    </v-container>
  </v-content>
</template>

<script lang="ts">
import { Vue, Component, PropSync } from 'vue-property-decorator'
import moment from 'moment'

import { CallDetailsInformation } from '@/types'
import config from '@/config'
import { getCallReportingHomeURL } from '@/utils'

@Component({
  filters: {
    formatTime (time: string) {
      return time ? moment(time, ['HH:mm']).format('h:mm A') : null
    }
  }
})
export default class Confirmation extends Vue {
  @PropSync('formStep')
  private step!: 'Details' | 'Review' | 'Confirmation'

  @PropSync('callDetails')
  private data!: CallDetailsInformation

  private onSubmit () {
    // TODO: send request
    this.step = 'Confirmation'
  }

  private get isMagenta () {
    return config.isMagenta
  }

  private get getCallReportingHomeURL () {
    return getCallReportingHomeURL()
  }

  private get formattedPhoneNumber () {
    const phoneNumber = this.data.number

    function formatPhoneNumber (phoneNumber: string) {
      const npa = phoneNumber.slice(0, 3)
      const nxx = phoneNumber.slice(3, 6)
      const local = phoneNumber.slice(6, 10)

      return `(${npa}) ${nxx}-${local}`
    }

    if (phoneNumber.length === 10) {
      return formatPhoneNumber(phoneNumber)
    } else if (phoneNumber.length === 11 && phoneNumber.startsWith('1')) {
      return '+1 ' + formatPhoneNumber(phoneNumber.slice(-10))
    } else {
      return phoneNumber
    }
  }
}
</script>
